module.exports = __webpack_public_path__ + "static/media/kristy.3ac267b2.png";